import React from "react";
import {
    Box,
    Typography,
    Container,
    Grid,
    Paper,
    Chip,
} from "@mui/material";
import { textAlign } from "@mui/system";

const SkillsExpertise = () => {
    return (
        <Box sx={{ backgroundColor: "#f2f2f2", py: 5,px:{xs:"auto",md:'50px'} }}>
            <Container >
                {/* SECTION TITLE */}
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                        mb: 4,
                    }}
                >
                    <Typography
                        variant="h4"
                        sx={{
                            fontFamily: "'Playfair Display', serif !important",
                           fontSize: {xs:"20px",md:"38px"},
                            fontWeight: 600,
                            color: "#0f2e4d",
                            whiteSpace: "nowrap",
                        }}
                    >
                        Skills & Expertise
                    </Typography>

                    <Box
                        sx={{
                            flex: 1,
                            height: "1px",
                            background:
                                "linear-gradient(to right, #0f63a5, transparent)",
                        }}
                    />
                </Box>

                {/* GRID SECTION */}
                <Grid container columnSpacing={3}   // space between left & right columns
                    rowSpacing={10}  >
                    {/* SALES & CONSULTING */}
                    <Grid item xs={12} md={6}>
                        <Paper
                            elevation={0}
                            sx={cardStyle}
                        >
                            <Typography sx={cardTitle}>
                                Sales & Consulting
                            </Typography>

                            <Box sx={chipWrapper}>
                                {[
                                    "Consultative Selling",
                                    "Luxury Market Expertise",
                                    "SPIN Selling",
                                    "NEAT Framework",
                                    "NLP",
                                    "Lead Qualification",
                                    "Objection Handling",
                                    "Sales Strategy",
                                ].map((skill, i) => (
                                    <Chip key={i} label={skill} sx={chipStyle} />
                                ))}
                            </Box>
                        </Paper>
                    </Grid>

                    {/* LEADERSHIP */}
                    <Grid item xs={12} md={6}>
                        <Paper elevation={0} sx={cardStyle}>
                            <Typography sx={cardTitle}>
                                Leadership & Development
                            </Typography>

                            <Box sx={chipWrapper}>
                                {[
                                    "Mentoring",
                                    "Coaching",
                                    "Team Building",
                                    "Training",
                                    "Behavioral Psychology",
                                    "Brand Strategy",
                                    "GTM Strategy",
                                    "Process Refinement",
                                ].map((skill, i) => (
                                    <Chip key={i} label={skill} sx={chipStyle} />
                                ))}
                            </Box>
                        </Paper>
                    </Grid>

                    {/* LANGUAGES */}
                    <Grid item xs={12} md={6}>
                        <Paper elevation={0} sx={cardStyle}>
                            <Typography sx={cardTitle}>
                                Languages
                            </Typography>

                            <Box sx={chipWrapper}>
                                {["English", "Telugu", "Hindi", "Tamil"].map(
                                    (lang, i) => (
                                        <Chip key={i} label={lang} sx={chipStyle} />
                                    )
                                )}
                            </Box>
                        </Paper>
                    </Grid>

                    {/* CERTIFICATIONS */}
                    <Grid item xs={12} md={6}>
                        <Paper elevation={0} sx={cardStyle}>
                            <Typography sx={cardTitle}>
                                Certifications
                            </Typography>


                            <Box component="ul" sx={{ pl: 2, m: 0 }}>
                                {[
                                    "1% Leadership: How Tiny Changes Forge Great Leaders",
                                    "Enhance Your Coaching Impact with Generative AI",
                                    
                                ].map((item, index) => (
                                    <Typography

                                        component="li"
                                        key={index}
                                        sx={{
                                            fontFamily: "'Lato', sans-serif !important",
                                            fontSize: "14px !important",
                                            color: "#444",
                                            lineHeight: 1.8,
                                            mb: 0.8,
                                            listStyleType: "disc",
                                            paddingLeft: "5px",
                                            margin: 0,
                                            "& li::marker": {
                                                color: "#000",
                                            },
                                            textAlign: 'start'
                                        }}
                                    >
                                        {item}
                                    </Typography>
                                ))}
                            </Box>
                        </Paper>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};

export default SkillsExpertise;

/* ---------- STYLES ---------- */

const cardStyle = {
    backgroundColor: "#f7f7f7",
    borderRadius: "12px",
    p: 2,
    borderLeft: "6px solid #0f63a5",
    boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
    height: "100%",
};

const cardTitle = {
    fontFamily: "'Playfair Display', serif !important",
    fontSize: "18px",
    fontWeight: 600,
    color: "#0f2e4d",
    mb: 2,
    textAlign: 'start'
};

const chipWrapper = {
    display: "flex",
    flexWrap: "wrap",
    gap: 1.2,
};

const chipStyle = {
    fontSize: "12px !important",
    fontFamily: "'Lato', sans-serif !important",
    backgroundColor: "#f1f1f1",
    border: "1px solid #d6d6d6",
    borderRadius: "20px",
    px: 1,
    height: "34px",
};

const certItem = {
    fontSize: "14px",
    fontFamily: "'Lato', sans-serif !important",
    color: "#333",
    lineHeight: 1.8,
    //   mb: 4,
};